import React from 'react';
import ReactDOM from 'react-dom';
import { nanoid } from 'nanoid';
import '@quan/env';
import XHR from '@/services/xhr';
import promiseFinally from 'promise.prototype.finally';
import '../index.css';
import { browserRegister } from '@quan/shared';
import 'antd-mobile/es/global';
import { debug } from '@/utils';
import { DEVIS_ID_KEY } from '@/services/const';
promiseFinally.shim();

XHR();
debug();
browserRegister();

if (process.env.mode) {
  const DEVIS_ID = localStorage.getItem(DEVIS_ID_KEY) || nanoid();
  localStorage.setItem(DEVIS_ID_KEY, DEVIS_ID);
}

const render = (root: React.ReactNode) => {
  ReactDOM.render(<React.StrictMode>{root}</React.StrictMode>, document.getElementById('root'));
};

export default render;
